<!-- 運搬子要素 -->
<template>
  <draggable
    :group="{ name: 'undistributed', pull: false, put: putCheck }"
    :list="schedules"
    :name="`dragArea_${targetDriverId}`"
    typeable="nested"
    class="dragArea nested"
    tag="ul"
  >
    <li
      v-for="task in schedules"
      :key="task.id"
      :class="task.schedule_type"
      class="rounded-card"
    >
      <v-card
        class="fill-height rounded-card"
        flat
        :class="cardStyle(task)"
      >
        <v-card-text
          style="height: 100%;padding: 1px 1px 1px 4px"
        >
          <v-badge
            v-if="task.schedule_type === 'destination'"
            inline
            color="white"
            class="customBadge"
          >
            <template v-slot:badge>
              <span style="color:#1EABD1;" class="font-weight-bold">{{ task.schedule_type | task_type_label }}</span>
            </template>
          </v-badge>
        </v-card-text>
      </v-card>
    </li>
  </draggable>
</template>


<script>
import Draggable from 'vuedraggable'

export default {
  name: 'AllocationNestedTask',
  components: {
    Draggable,
  },
  mixins: [],
  props: {
    targetDriverId: {
      type: Number,
      default: () => null,
    },
    parentSchedule: {
      type: Object,
      default: () => {}
    },
    /**
     * ドライバーのタスク
     */
    schedules: {
      type: Array,
      default: () => []
    },
    targetDate: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {
  },
  created() {
  },
  methods: {
    putCheck (to, from) {
      let fromName = from.options.name
      let toName   = to.options.name
      let toType = to.options.typeable
      // 受注一覧からのドラッグの場合は運搬先へのドロップを許可しない
      if (fromName.match(/main_task/) || fromName  === 'toName' || fromName  === 'unspecified_task') {
        return (toType !== 'nested')
      }

      // 同リスト内のみ移動可能
      return (fromName === toName)
    },
    cardStyle (task) {
      let style = []
      if (task.schedule_type === 'destination') {
        style.push('info')
      }
      if (task.confirmed) {
        style.push('confirmed')
      }
      return style.join(' ')
    },
  }
}
</script>

<style scoped lang="scss">
.hide {
  display: none;
}
ul.dragArea {
  list-style-type: none;
  &.nested {
    opacity: 0;
    top: 0;
    position: absolute;
    height: 100%;
    z-index: 3;
    width: 100%;
    & li {
      display: none;
    }
  }
  & li {
    position: relative;
    float: left;
    //height: 50px;
    height: 73px;
    width: 150px;
    border: 1px solid #ddd;
    margin: 0 3px;

    & h5 {
      white-space:nowrap;
      width: 80%;
      overflow:hidden;
      text-overflow:ellipsis;
    }

    &.destination {
      width: 80px;
      & h5 {
        color: white !important;
        & span {
          color: white !important;
        }
      }
    }
    &.instruction {
      width: 90px;
      & .v-card {
        background-color: #FDEFC1 !important;
      }
    }
  }
}
</style>
